import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'swapCase'
})
export class SwapCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
